<template>
    <nav class="py-2 border-t border-gray-200 flex items-center justify-between sm:px-6 lg:px-8">
        <div class="-mt-px w-0 flex-1 flex">
            <Link as="button" :href="getPreviousLink().url" :disabled="!getPreviousLink().url" class="border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
                <ArrowNarrowLeftIcon class="mr-3 h-5 w-5 text-gray-400" aria-hidden="true" />
                Previous
            </Link>
        </div>
        <div class="hidden md:-mt-px md:flex">
            <template v-for="item in getFullNavItems()">
                <Link v-if="item.url" :href="item.url" :class="item.active ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500'"
                      class="border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium" aria-current="page"> {{ item.label }} </Link>
                <span v-if="!item.url" class="border-transparent text-gray-500 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium"> ... </span>
            </template>
        </div>
        <div class="-mt-px w-0 flex-1 flex justify-end">
            <Link as="button" :href="getNextLink().url" :disabled="!getNextLink().url" class="border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
                Next
                <ArrowNarrowRightIcon class="ml-3 h-5 w-5 text-gray-400" aria-hidden="true" />
            </Link>
        </div>
    </nav>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import { ArrowNarrowLeftIcon, ArrowNarrowRightIcon } from '@heroicons/vue/solid'

export default {
    props: {
        pagination: Object,
    },
    components: {
        Link,
        ArrowNarrowLeftIcon,
        ArrowNarrowRightIcon,
    },
    methods: {
        getNextLink() {
            return this.pagination.links[this.pagination.links.length - 1];
        },
        getPreviousLink() {
            return this.pagination.links[0];
        },
        getFullNavItems() {
            return this.pagination.links.slice(1, this.pagination.links.length - 1);
        },
    }
}
</script>
